<template>
    <b-modal
            :code="code"
            id="modal-center" centered header-class="qr-modal-header" hide-footer>
        <template #modal-header="">

            <qrcode-vue class="qr-code" :value="code" :size="size" level="H" />
            <span class="qr-code-text">{{code}}</span>
            <b-container>
                <b-row>
                    <b-col>
                        <h3 class="your-qr-code">Your QR Code</h3>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col>
                        <p class="qr-code__des">Your QR Code will be sent to your registered mobile number.</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p class="text-sm">* Your QR Code will be available in your <span class="text-green">accounts</span> section.</p>
                    </b-col>
                </b-row>
            </b-container>
        </template>
    </b-modal>
</template>
<script>
    import QrcodeVue from 'qrcode.vue';
export default {
    props: {
        code: {
            type: String,
            default: ''
        }
    },
    components:{
        QrcodeVue
    },
    data() {
        return {
            size: 200,
        }
    },
}
</script>
